/* Sample Service: one per basket, enforced.

   THE RULE (client, 17 Aug 2026): a basket may contain at most ONE Sample
   Service. Not two lines, not one line at quantity 2, by any route.

   WHY IT IS HOOKED AT THE NETWORK LAYER, NOT ON THE CONTROLS
   The theme offers at least five ways to change a basket quantity: the +/-
   buttons, the number input, the popout dropdown (which replaces the input
   under 10), quick add from the grid, and the PDP form. Binding to each one
   means finding each one, and missing the sixth. Every one of them ends up at
   /cart/add.js or /cart/change.js, so that is where this sits. It catches
   routes we have not thought of, including a stale drawer or a pasted
   permalink, which is the same reasoning as snippets/cart-options-guard.liquid.

   WHAT IT DOES
   - /cart/add   with the sample, when one is already in the basket, or with
                 quantity > 1: blocked outright, popup shown, nothing added.
   - /cart/change or /cart/update setting the sample above 1: the payload is
     REWRITTEN to 1 rather than rejected, so the basket visibly snaps back with
     an explanation instead of silently ignoring the click.
   - On load, and after any change, a sweep: if the basket somehow holds more
     than one (JS disabled earlier in the session, a a third-party app, an old
     tab), it is corrected to 1 and the popup explains why.

   THIS IS THE FIRST GATE, NOT THE ONLY ONE. snippets/cart-sample-limit-guard
   .liquid disables checkout server-side if a basket ever reaches checkout with
   more than one, so the rule holds even with JavaScript off or erroring.

   Config is rendered from Liquid into window.PH_SAMPLE_LIMIT by
   sections/cart-drawer.liquid, so variant IDs and copy are never hardcoded
   here and follow the product and the locale. */

(function () {
  'use strict';

  var CFG = window.PH_SAMPLE_LIMIT;
  if (!CFG || !CFG.ids || !CFG.ids.length) return;

  var MAX = CFG.max || 1;
  var IDS = CFG.ids.map(String);
  var busy = false;

  function isSample(id) {
    return IDS.indexOf(String(id)) !== -1;
  }

  /* ---------------------------------------------------------------- popup */

  function popup(message) {
    var existing = document.querySelector('.ph-sample-limit');
    if (existing) existing.remove();

    var wrap = document.createElement('div');
    wrap.className = 'ph-sample-limit';
    wrap.setAttribute('role', 'alertdialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', CFG.title || 'The Sample Service');
    wrap.innerHTML =
      '<div class="ph-sample-limit__backdrop" data-close></div>' +
      '<div class="ph-sample-limit__panel">' +
      '<p class="ph-sample-limit__title">' + (CFG.title || '') + '</p>' +
      '<p class="ph-sample-limit__body">' + message + '</p>' +
      '<button type="button" class="ph-sample-limit__btn" data-close>' +
      (CFG.dismiss || 'Continue') + '</button>' +
      '</div>';

    document.body.appendChild(wrap);

    var btn = wrap.querySelector('.ph-sample-limit__btn');
    if (btn) btn.focus();

    function close() {
      wrap.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
    }
    wrap.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close')) close();
    });
    document.addEventListener('keydown', onKey);
  }

  /* ------------------------------------------------------------ cart read */

  function getCart() {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function sampleQty(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (isSample(item.variant_id)) n += item.quantity;
    });
    return n;
  }

  function sampleKeys(cart) {
    return (cart.items || [])
      .filter(function (i) { return isSample(i.variant_id); })
      .map(function (i) { return i.key; });
  }

  /* ------------------------------------------------ payload interrogation */

  // /cart/add and /cart/change accept JSON, FormData or urlencoded. Normalise
  // to a plain object so one set of rules covers all three.
  function readBody(body) {
    try {
      if (!body) return null;
      if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') return { kind: 'json', data: JSON.parse(body) };
        var o = {};
        new URLSearchParams(body).forEach(function (v, k) { o[k] = v; });
        return { kind: 'url', data: o };
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var f = {};
        body.forEach(function (v, k) { f[k] = v; });
        return { kind: 'form', data: f, raw: body };
      }
    } catch (e) { /* unreadable body: let it through, the server guard still holds */ }
    return null;
  }

  function addOffends(data, currentQty) {
    // Single add: { id, quantity } . Multi add: { items: [ {id, quantity} ] }.
    var lines = data.items && data.items.length ? data.items : [data];
    var asked = 0;
    for (var i = 0; i < lines.length; i++) {
      var id = lines[i].id || lines[i]['id'];
      if (id && isSample(id)) asked += parseInt(lines[i].quantity, 10) || 1;
    }
    if (!asked) return false;
    return (currentQty + asked) > MAX;
  }

  // Does this add payload reference the sample at all? Cheap, local, no network.
  // Everything the limiter does downstream is only meaningful when it does.
  function mentionsSample(data) {
    var lines = data.items && data.items.length ? data.items : [data];
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].id && isSample(lines[i].id)) return true;
    }
    return false;
  }

  /* --------------------------------------------------------- fetch patch */

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var opts = init || {};
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var isChange = /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);

      if (!isAdd && !isChange) return nativeFetch.apply(this, arguments);

      var parsed = readBody(opts.body);
      if (!parsed) return nativeFetch.apply(this, arguments);

      if (isAdd) {
        var self = this, args = arguments;

        // An add that does not involve the sample is none of this script's
        // business, so it goes straight to the network. This matters because
        // sample-service-limit.js loads on EVERY page (the script tag lives in
        // cart-drawer.liquid) and patches window.fetch globally: without this
        // line, every add-to-cart on the site paid for a /cart.js round trip
        // first, on products the limiter does not police.
        if (!mentionsSample(parsed.data)) return nativeFetch.apply(this, arguments);

        // FAIL OPEN on a basket we could not read. /cart.js can 429 (Shopify
        // rate-limits it, reproduced 21 Aug 2026), time out, or fail offline.
        // Before this, the whole chain rejected and the add was silently
        // dropped: nothing in the basket, no error shown, customer gone.
        // Letting it through costs nothing, because the server gate in
        // snippets/cart-sample-limit-guard.liquid still refuses checkout on an
        // over-limit basket.
        //
        // The catch sits on getCart() ALONE, deliberately. Wrapped around the
        // whole chain it also swallows a throw from popup() below, which would
        // turn a failed popup into a silently ALLOWED second sample. Scoped
        // here, a network failure opens the gate and nothing else can.
        return getCart().catch(function () { return null; }).then(function (cart) {
          if (cart && addOffends(parsed.data, sampleQty(cart))) {
            try { popup(CFG.message_add); } catch (e) { /* never unblock on a UI failure */ }
            // Resolve rather than reject: a rejection surfaces as a generic
            // theme error toast on top of our popup. An empty 200 lets the
            // theme's own handler finish quietly.
            return new Response(JSON.stringify({ items: [] }), {
              status: 200, headers: { 'Content-Type': 'application/json' }
            });
          }
          return nativeFetch.apply(self, args);
        });
      }

      // change/update: clamp instead of block
      var clamped = clampChange(parsed);
      if (clamped.changed) {
        popup(CFG.message_qty);
        opts.body = clamped.body;
        return nativeFetch.call(this, input, opts).then(function (r) {
          sweepSoon();
          return r;
        });
      }
      return nativeFetch.apply(this, arguments).then(function (r) {
        sweepSoon();
        return r;
      });
    };
  }

  // Rewrites a change/update payload so the sample never exceeds MAX.
  function clampChange(parsed) {
    var d = parsed.data, changed = false;

    // /cart/change.js  { id|line, quantity }
    if (d.quantity !== undefined && (d.id !== undefined || d.line !== undefined)) {
      var q = parseInt(d.quantity, 10);
      if (q > MAX && matchesSampleLine(d.id, d.line)) { d.quantity = MAX; changed = true; }
    }

    // /cart/update.js  { updates: { key: qty } }
    if (d.updates && typeof d.updates === 'object') {
      Object.keys(d.updates).forEach(function (k) {
        if (parseInt(d.updates[k], 10) > MAX && LAST_KEYS.indexOf(k) !== -1) {
          d.updates[k] = MAX; changed = true;
        }
      });
    }

    if (!changed) return { changed: false };
    if (parsed.kind === 'json') return { changed: true, body: JSON.stringify(d) };
    if (parsed.kind === 'url') return { changed: true, body: new URLSearchParams(d).toString() };
    var fd = new FormData();
    Object.keys(d).forEach(function (k) { fd.append(k, d[k]); });
    return { changed: true, body: fd };
  }

  // The sample's line keys, refreshed on every sweep. /cart/change identifies a
  // line by key or 1-based index, neither of which carries the variant id, so
  // the mapping has to be held here.
  var LAST_KEYS = [];
  var LAST_INDEXES = [];

  function matchesSampleLine(id, line) {
    if (id !== undefined && LAST_KEYS.indexOf(String(id)) !== -1) return true;
    if (line !== undefined && LAST_INDEXES.indexOf(parseInt(line, 10)) !== -1) return true;
    return false;
  }

  /* ----------------------------------------------------------- the sweep */

  var sweepTimer = null;
  function sweepSoon() {
    clearTimeout(sweepTimer);
    sweepTimer = setTimeout(sweep, 350);
  }

  function sweep(announce) {
    if (busy) return Promise.resolve();
    return getCart().then(function (cart) {
      LAST_KEYS = sampleKeys(cart);
      LAST_INDEXES = [];
      (cart.items || []).forEach(function (item, i) {
        if (isSample(item.variant_id)) LAST_INDEXES.push(i + 1);
      });

      var total = sampleQty(cart);
      if (total <= MAX) return;

      // Over the limit by some route we did not intercept. Correct it.
      busy = true;
      var keys = LAST_KEYS.slice();
      var keep = keys.shift();
      var updates = {};
      updates[keep] = MAX;
      keys.forEach(function (k) { updates[k] = 0; });

      return nativeFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        busy = false;
        if (announce !== false) popup(CFG.message_qty);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () { busy = false; });
    }).catch(function () { /* offline or blocked: the server guard still holds */ });
  }

  /* -------------------------------------------------------------- start */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sweep(); });
  } else {
    sweep();
  }

  // Keep the key/index map fresh when the theme rebuilds the basket.
  document.addEventListener('cart:updated', sweepSoon);
  document.addEventListener('cart:build', sweepSoon);
})();
